<template>
  <div class="all-contxt">
      <Header title="我的缓考申请"></Header>
      <div class="delay-search">
        <i class="search-icon" @click="searchMy()"></i>
        <input type="text" placeholder="搜索课程(名称或课号)" v-model="courseInfo">
      </div>
      <div class="search-info">
        <div class="sem-drop">
          <div @click="semPicker = true"><p>{{this.semester}}</p><i></i></div>
          <div @click="actTap()"><p>{{this.activity}}</p><i></i></div>
        </div>
        <van-popup v-model="semPicker" position="bottom">
          <van-picker show-toolbar :columns="option1" @cancel="semPicker = false" @confirm="semConfirm" :swipe-duration="500" :item-height="35"/>
        </van-popup>
        <van-popup v-model="actPicker" position="bottom">
          <van-picker show-toolbar :columns="option2" @cancel="actPicker = false" @confirm="actConfirm" :swipe-duration="500" :item-height="35"/>
        </van-popup>
        <!-- <van-dropdown-menu>
          <van-dropdown-item v-model="value1" :options="option1" @change="itemSelect"/>
          <van-dropdown-item v-model="value2" :options="option2" @open="courseShow"/>
        </van-dropdown-menu> -->
      </div>
      <NOdata title="未查询到缓考申请~" v-if="this.allWarnList.length == 0 && isLoad"></NOdata>
      <template v-else>
        <div class="grey-div" v-for="(item,index) in allWarnList" :key="index" >
        <a class="grey-contain" @click="goDetail(index)">
          <div class="context">
            <p class="contain-txt">{{item.courseName}}</p>
            <p class="contain-txt1" v-if="schoolCode=='10488'">考试时间：{{item.ksTime}}</p>
            <p class="contain-txt1" v-else>考试方式：{{item.examinationNature}}</p>
            <p class="contain-txt1">申请时间：{{item.applicationTime}}</p>
            <p class="contain-txt1" v-if="schoolCode=='10488'">前序审核意见：{{item.applicationYj}}</p>
          </div>
          <p :style="item.auditStatus == '通过' ? 'color: #12DDD6;' : 'color:#F86969;'">{{item.auditStatus}}</p>
        </a>
        <div class="grey-reset" v-if="item.auditStatus=='不通过'" @click="goApply(item)"><span >重新申请</span></div>
      </div>
      </template>
      <van-overlay :show="ksxzshow" @click="ksxzshow=false">
      <div class="ksxzcon">
        <div class="text">缓考须知</div>
        <div class="ksxz_wb" v-html="hkxzContext"></div>
        <van-button type="primary" color="#7469F8" block @click="toApply()">我已认证阅读,且充分理解上述规定,并 承若遵守上述规定</van-button>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Api } from '../../../utils/axios'
  export default {
    data() {
      return {
        courseInfo:'',
        semPicker:false,
        actPicker:false,
        semester:'学年学期',
        activity:'活动名称',
        allWarnList:[],
        timeValue: '',
        activityValue:'',
        value2: 0,
        option1: [{
          text:'学年学期',
          value:0,
          index:''
        }],
        option2: [{
          text:'活动名称',
          value:0,
          index:''
        }],
        activityId:'',
        isLoad:false,
        schoolCode:sessionStorage.getItem("schoolCode"),
        ksxzshow:false,
        nowApplyItem:{},
            hkxzContext:''
      }
    },
        created(){
          this.getMain()
          this.getSemList()
        },
        methods:{
          async getSemList(){
            let concatList = []
            const res = await Api.getSemesterList()
            res.data.forEach((item,index) => {
              concatList[index] = {
                text:item.semesterName,
                value:index + 1,
                index:item.semesterId
              }
            });
            this.option1 = this.option1.concat(concatList)
          },
          async getMain(){
            const res = await Api.getCurrentTerm()
            this.semester = res.data[0].semesterId
            this.getSlow(res.data[0].semesterId)
            this.itemSelect(res.data[0].semesterId)
          },
          async getSlow(val){
            const params = {
              semester:val,
              courseName: '',
              cj0701id: ''
            }
            const res = await Api.getMySlowExamination(params)
            this.allWarnList = res.data;
            this.hkxzContext = res.hkxzContext;
            this.isLoad = true;
          },
          actTap(){
            if(this.semester == '' || this.semester == '学年学期'){
              this.$toast.fail('请先选择学年学期')
            }else{
              this.actPicker = true
            }
          },
          semConfirm(e,val){
            this.semPicker = false
            this.semester = e.text
            this.searchMy()
            this.itemSelect(e.text)
          },
          actConfirm(e,val){
            this.actPicker = false;
            this.activity = e.text
            this.activityId = e.index
            this.searchMy()
          },
          goDetail(index){
            this.$router.push({
              path:'/student/myApply1',
              query:{
                'data':JSON.stringify(this.allWarnList[index])
              }
            })
          },
          courseShow(res){
            if(this.value1 == ''){
              this.$toast.fail('请先选择学年学期~')
            }
          },
          async itemSelect(index){
            this.option2 = [{
              text:'活动名称',
              value:0,
              index:''
            }]
            this.value2 = 0
            const params = {
              semester:index
            }
            const res = await Api.getActivityName(params)
            let concatList = []
            res.data.forEach((item,index) => {
              concatList[index] = {
                text:item.activityname,
                value:index + 1,
                index:item.cj0701id
              }
            });
            this.option2 = this.option2.concat(concatList)
          },
          async searchMy(){
            const params = {
              semester:this.semester == '学年学期' ? '' : this.semester,
              courseName:this.courseInfo,
              cj0701id:this.activityId == '活动名称' ? '' : this.activityId
            }
            const res = await Api.getMySlowExamination(params)
            this.allWarnList = res.data
          },
          goApply(item){
            this.ksxzshow = true;
            this.nowApplyItem = item;
          },
          toApply(){
            this.ksxzshow = false;
            this.nowApplyItem.reApply = '1';
            this.$router.push({
                path:'/student/delayApply',
                query:{
                  'data':JSON.stringify(this.nowApplyItem)
                }
              })
          }
        },
      }
</script>

<style lang="less" scoped>
  .delay-search{
    background-color: @attendance-background-color-6;
    border-radius:3px;margin: 20px 20px 0;
    padding: 11px 12px;display: flex;
    .search-icon{
      background: url(../../../../static/img/search.png)no-repeat center;
      width: 22px;height: 22px;background-size: 22px 22px;
    }
    input{
      background-color: @attendance-background-color-6;
      padding-left: 22px;flex: 1;color: @attendance-color-2;
    }
  }
  .search-info{
    display: flex;justify-content: center;
    border-bottom: 1px solid @attendance-border-color-6;
    padding: 20px 0 7px;
    .sem-drop{
      display: flex;
      width:90%;
      >div{
        display: flex;align-items: center;color: @attendance-color-2;font-size: 14px;
        justify-content: center;
        width: 45%;
        i{
          background: url(../../../../static/img/Triangle.png)no-repeat center;
          width: 10px;height: 10px;background-size: 10px 8px;margin-left: 5px;
        }
      }
    }
  }
  .all-contxt{
    padding-left: 20px;
    padding-right: 20px;
  }
  .grey-contain{
    margin: 0px;
    >p{
      font-size: 14px;font-weight: 500;
    }
  }
  .context{
    padding-top: 10px;
    padding-bottom: 10px
  }
  .contain-txt1{
    max-width: 240px;
  }
  .grey-reset{
    width: 100%;
    text-align: right;
    padding-top: 10px;
    padding-bottom: 16px;
    span{
       background-color: #7469F8;
       color: #fff;
       padding: 6px 6px 6px 6px;
       border-radius: 5px;
       font-size: 14px;
       font-weight: 400;
    }
  }
  .grey-div{
    margin-bottom: 20px;
  }
  .ksxzcon{
  width: 100%;
  padding:20px 20px 0 20px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
  padding-bottom: 10px;
  margin-top: 150px;
}
.text{
  font-size: 18px;
  color: #333;
}
.ksxz_wb{
  width: 100%;
  background: #f2f2f4;
  padding:10px;
  box-sizing: border-box;
  font-size: 12px;
  color: #333;
  border-radius: 6px;
  margin:8px 0 10px;
  min-height: 350px;
}
.ksxzcon .van-button{
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/student/delayTest/myApply.vue